interface FeatureIconProps {
  type: string;
}

export const FeatureIcon = ({ type }: FeatureIconProps) => {
  let icon = null;

  switch (type) {
    case 'up':
      icon = <Up />;
      break;
    case 'mobile':
      icon = <Mobile />;
      break;
    case 'cal':
      icon = <Cal />;
      break;
    case 'sun':
      icon = <Sun />;
      break;
    case 'world':
      icon = <World />;
      break;
    case 'mountains':
      icon = <Mountains />;
      break;
    case 'gift':
      icon = <Gift />;
      break;
    default:
      icon = <Store />;
  }

  return <div className="mb-8">{icon}</div>;
};

const Up = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="138" height="138" rx="23" fill="#FCF2CD" />
    <path
      opacity="0.8"
      d="M18.6436 78.3557L-11.3046 104.884C-13.0187 106.403 -14 108.583 -14 110.873V146C-14 150.418 -10.4183 154 -6 154H146C150.418 154 154 150.418 154 146V42.0495C154 35.1098 145.769 31.4614 140.627 36.1222L110.825 63.1368C108.208 65.5092 104.345 65.8843 101.32 64.0599L89.7819 57.0998C86.7006 55.2412 82.7576 55.6686 80.1461 58.1441L49.9967 86.7237C47.0177 89.5476 42.3848 89.6587 39.2739 86.9808L29.1673 78.281C26.1344 75.6703 21.6391 75.7022 18.6436 78.3557Z"
      fill="white"
      className="animate-down"
    />
    <path
      d="M70 38V86M51.3334 56.6667L70 38L51.3334 56.6667ZM70 38L88.6667 56.6667L70 38Z"
      stroke="#FBCC26"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="animate-up"
    />
    <g opacity="0.6">
      <path
        d="M38 83V107M28.6666 92.3333L38 83L28.6666 92.3333ZM38 83L47.3333 92.3333L38 83Z"
        stroke="#FBCC26"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="animate-up-small"
      />
    </g>
    <g opacity="0.6">
      <path
        d="M102 74V98M92.6666 83.3333L102 74L92.6666 83.3333ZM102 74L111.333 83.3333L102 74Z"
        stroke="#FBCC26"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="animate-up-small-2"
      />
    </g>
    <rect
      x="1"
      y="1"
      width="138"
      height="138"
      rx="23"
      stroke="#FBCC26"
      strokeWidth="2"
    />
  </svg>
);

const Mobile = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="138" height="138" rx="23" fill="#FCF2CD" />
    <path
      opacity="0.8"
      d="M34 36C34 29.3726 39.3726 24 46 24H94C100.627 24 106 29.3726 106 36V140H34V36Z"
      fill="white"
    />
    <path
      d="M54 24H86V26C86 28.2091 84.2091 30 82 30H58C55.7909 30 54 28.2091 54 26V24Z"
      fill="#FCF2CD"
    />
    <rect
      x="42"
      y="48"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
      className="animate-scale"
    />
    <rect
      opacity="0.2"
      x="42"
      y="69"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="42"
      y="90"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="62"
      y="48"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="62"
      y="69"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="62"
      y="90"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="82"
      y="48"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="82"
      y="69"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      x="1"
      y="1"
      width="138"
      height="138"
      rx="23"
      stroke="#FBCC26"
      strokeWidth="2"
    />
  </svg>
);

const Store = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="138" height="138" rx="23" fill="#FCF2CD" />
    <path
      opacity="0.8"
      d="M22 40C22 37.7909 23.7909 36 26 36H114C116.209 36 118 37.7909 118 40V96C118 100.418 114.418 104 110 104H30C25.5817 104 22 100.418 22 96V40Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M22 40C22 37.7909 23.7909 36 26 36H114C116.209 36 118 37.7909 118 40V48H22V40Z"
      fill="#FBCC26"
    />
    <path
      d="M84.8949 87.5531L75.8949 69.5531C75.8181 69.3995 75.703 69.2683 75.5608 69.172C75.4186 69.0757 75.2541 69.0175 75.0829 69.0031C74.9119 68.9902 74.7405 69.021 74.5846 69.0925C74.4288 69.1641 74.2936 69.274 74.1919 69.4121L66.8079 79.5651L62.6249 76.2181C62.5106 76.1273 62.3778 76.0626 62.2358 76.0284C62.0939 75.9943 61.9462 75.9915 61.803 76.0204C61.6599 76.0493 61.5248 76.109 61.4072 76.1955C61.2895 76.282 61.1922 76.3931 61.1219 76.5211L55.1219 87.5211C55.0388 87.6734 54.9968 87.8447 54.9999 88.0182C55.0031 88.1917 55.0513 88.3614 55.1399 88.5106C55.2284 88.6598 55.3543 88.7834 55.5051 88.8692C55.6559 88.955 55.8264 89.0001 55.9999 89.0001H83.9999C84.1703 88.9999 84.3378 88.9562 84.4866 88.8732C84.6354 88.7902 84.7605 88.6706 84.8501 88.5257C84.9397 88.3808 84.9909 88.2154 84.9987 88.0452C85.0066 87.875 84.9709 87.7056 84.8949 87.5531Z"
      fill="#FBCC26"
      className="animate-appear-2"
    />
    <path
      d="M64 71C66.2091 71 68 69.2091 68 67C68 64.7909 66.2091 63 64 63C61.7909 63 60 64.7909 60 67C60 69.2091 61.7909 71 64 71Z"
      fill="#FBCC26"
      className="animate-appear-1"
    />
    <rect
      x="1"
      y="1"
      width="138"
      height="138"
      rx="23"
      stroke="#FBCC26"
      strokeWidth="2"
    />
  </svg>
);

const Cal = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="138" height="138" rx="23" fill="#FCF2CD" />
    <rect
      opacity="0.8"
      x="32"
      y="40"
      width="76"
      height="68"
      rx="8"
      fill="white"
    />
    <line
      x1="53"
      y1="31"
      x2="53"
      y2="49"
      stroke="#FBCC26"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="87"
      y1="31"
      x2="87"
      y2="49"
      stroke="#FBCC26"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      className="animate-flash-1"
      x="40"
      y="63"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="40"
      y="84"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      className="animate-flash"
      x="62"
      y="63"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="62"
      y="84"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="84"
      y="63"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      opacity="0.2"
      x="84"
      y="84"
      width="16"
      height="16"
      rx="2"
      fill="#FBCC26"
    />
    <rect
      x="1"
      y="1"
      width="138"
      height="138"
      rx="23"
      stroke="#FBCC26"
      strokeWidth="2"
    />
  </svg>
);

const Sun = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="64"
    height="64"
  >
    <circle cx="32" cy="32" r="32" fill="#FEF9E6" />
    <circle
      cx="32"
      cy="32"
      r="28"
      stroke="#fff"
      strokeOpacity=".5"
      strokeWidth="8"
    />
    <path
      d="M31.667 20v1.333V20Zm0 22.667V44v-1.333Zm12-10.667h-1.333 1.333ZM21 32h-1.333H21Zm19.152 8.485-.942-.942.942.942ZM24.124 24.457l-.942-.942.942.942Zm16.028-.942-.942.942.942-.942ZM24.124 39.543l-.942.942.942-.942ZM37 32a5.333 5.333 0 1 1-10.666 0A5.333 5.333 0 0 1 37 32v0Z"
      stroke="#101010"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const World = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    height="64"
    width="64"
  >
    <circle cx="32" cy="32" r="32" fill="#FEF9E6" />
    <circle
      cx="32"
      cy="32"
      r="28"
      stroke="#fff"
      strokeOpacity=".5"
      strokeWidth="8"
    />
    <path
      d="M20.073 30.667h2.594a2.667 2.667 0 0 1 2.666 2.666v1.334A2.667 2.667 0 0 0 28 37.333 2.667 2.667 0 0 1 30.667 40v3.927m-4-22.68v2.086A3.334 3.334 0 0 0 30 26.667h.667a2.667 2.667 0 0 1 2.666 2.666 2.667 2.667 0 0 0 5.334 0 2.667 2.667 0 0 1 2.666-2.666h1.419M36 43.317 35.5 40c0-.707-.327-1.673.5-2.5 1-1 1.96-.948 2.667-.948l4.085.781M44 32a12 12 0 1 1-24.002 0A12 12 0 0 1 44 32Z"
      stroke="#101010"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Gift = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    height="64"
    width="64"
  >
    <circle cx="32" cy="32" r="32" fill="#FEF9E6" />
    <circle
      cx="32"
      cy="32"
      r="28"
      stroke="#fff"
      strokeOpacity=".5"
      strokeWidth="8"
    />
    <path
      d="M22.667 32v9.333A2.667 2.667 0 0 0 25.333 44h13.334a2.667 2.667 0 0 0 2.666-2.667V32M32 26.667V44 26.667Zm0 0V24a2.667 2.667 0 1 1 2.667 2.667H32Zm0 0v-3.334a3.333 3.333 0 1 0-3.333 3.334H32ZM22.667 32h18.666-18.666Zm0 0a2.667 2.667 0 0 1 0-5.333h18.666a2.667 2.667 0 1 1 0 5.333H22.667Z"
      stroke="#101010"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Mountains = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    height="64"
    width="64"
  >
    <circle cx="32" cy="32" r="32" fill="#FEF9E6" />
    <circle
      cx="32"
      cy="32"
      r="28"
      stroke="#fff"
      strokeOpacity=".5"
      strokeWidth="8"
    />
    <path
      d="m21.333 37.333 6.115-6.114a2.667 2.667 0 0 1 3.77 0l6.115 6.114m-2.667-2.666 2.115-2.115a2.667 2.667 0 0 1 3.77 0l2.115 2.115m-8-8h.014m-10.68 16h16A2.667 2.667 0 0 0 42.666 40V24A2.667 2.667 0 0 0 40 21.333H24A2.666 2.666 0 0 0 21.333 24v16A2.667 2.667 0 0 0 24 42.667Z"
      stroke="#101010"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
